import styled from '@emotion/styled'
import { Checkbox, Form } from 'antd'
import Auth from 'api/Auth'
import { Tracker } from 'api/Tracker'
import Utils from 'api/Utils'
import appsumo_logo from 'assets/appsumo_logo.svg'
import asters_logo from 'assets/asters_logo.svg'
import appsumo_heart from 'assets/icons/appsumo_hert.svg'
import LoadingIcons from 'assets/loading.json'
import WrongIcons from 'assets/wrong_anim.json'
import { Box, Button, Input, Spacer } from 'components'
import { useState } from 'react'
import Lottie from 'react-lottie'
import { T } from 'translation/i18n'
import { AppStore, showError } from 'utils'
import {
  TRACKEREVENTS,
  getUtmProperties,
  setAuthProperties,
  setStripeSignupData,
  setUserSignupData,
  setWorkspacesData,
} from 'utils/eventsTracker'
import { reloadApp } from 'utils/router'

export const AppsumoSignupCard = ({
  onLoginCallback,
  licenseKey
}: {
  onChangeSelected: () => void
  onLoginCallback: any
  licenseKey: string | null
}) => {
  enum SIGNUPSTEPS {
    SIGNUP_FORM = 0,
    PROFESSION_STEP = 1,
    LOGIN_STEP = 2,
    ERROR_STEP = 3,
  }
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [referral, setReferral] = useState(AppStore.referralCode ?? '')
  const [termsCheckbox, setTermsCheckbox] = useState(false)
  const [privacyCheckbox, setPrivacyCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showreferral, setShowreferral] = useState(false)
  //STEP 0: Iscrizione, STEP 1: Selezione professione, STEP 2: Correct server response, STEP 3: wrong server response
  const [signUpStep, setSignUpStep] = useState(SIGNUPSTEPS.SIGNUP_FORM)
  const categories = ['Privato', 'Libero professionista', 'Influencer', 'Azienda', 'Agenzia']

  let signingUp = false

  const resetState = () => {
    setName('')
    setEmail(AppStore.parampsOption?.defaultEmail ?? '')
    setPassword('')
    setReferral(AppStore.referralCode ?? '')
    setTermsCheckbox(false)
    setPrivacyCheckbox(false)
    setShowreferral(false)
  }

  const onSignup = async (category: string) => {
    Tracker.trackEvent(TRACKEREVENTS.SIGNUP_INITIATED, {
      ...setAuthProperties({ auth_method: 'Email', referral_code: referral }),
      ...getUtmProperties(),
    })

    try {
      if (signingUp) return
      if (!licenseKey) return

      signingUp = true

      const user = await Auth.signup(
        name,
        password,
        email,
        category,
        (window as any)?.Rewardful?._cookie?.affiliate?.token,
        referral, 
        licenseKey,
      )

      try {
        const signupSuccessTrackProperties = {
          ...setUserSignupData(user),
          ...setStripeSignupData(user),
          ...setAuthProperties({ auth_method: 'Email', referral_code: referral }),
          ...setWorkspacesData(user),
          ...getUtmProperties(),
        }
        Tracker.trackEvent(TRACKEREVENTS.SIGNUP_SUCCESSFUL, signupSuccessTrackProperties)
      } catch (error) { }

      onLogin(true)
    } catch (error: any) {
      if (error.toString() === 'Error: USER_ALREADY_EXISTS') {
        showError(T.error.user_already_exist)
      }
      Tracker.trackEvent(
        TRACKEREVENTS.SIGNUP_FAILED,
        setAuthProperties({
          auth_method: 'Email',
          error_message: `An error occured. \n ${error}`,
        })
      )
      setSignUpStep(SIGNUPSTEPS.ERROR_STEP)
    }
    signingUp = false
  }


  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoadingIcons,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const wrongOptions = {
    loop: true,
    autoplay: true,
    animationData: WrongIcons,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const renderSignUpForm = () => {
    return (
      <Box flex>
        <Form
          style={{ display: 'flex', flex: 1, flexDirection: 'column' }}
          onFinish={() => {
            if (!termsCheckbox) return showError({ message: T.error.acceptTerm })
            if (!privacyCheckbox) return showError({ message: T.error.acceptPrivay })

            const defaultcategory = 'Privato'
            onSignup(defaultcategory)
          }}
          autoComplete="off"
        >
          <Box height={358}>
            <Box mv={20} style={{ display: 'flex', justifyContent: 'space-between', flex: 1, flexDirection: 'row', alignItems: 'center' }}>
              <img style={{ height: 50 }} src={asters_logo} alt="Asters" />
              <img style={{ height: 35 }} src={appsumo_heart} alt="Heart" />
              <img style={{ height: 23 }} src={appsumo_logo} alt="Appsumo" />
              
            </Box>
            <Box hcenter mv={20}>
              <span style={{fontWeight: 700, fontSize: '27px', lineHeight: '34.56px'}}>{T.appsumo.welcome}</span>
            </Box>
            <Box flex>
              <Form.Item name="name" rules={[{ required: true }]}>
                <Input flex onChange={(txt) => setName(txt)} variant="name" />
              </Form.Item>
              <Spacer />
              <Form.Item name="email" rules={[{ required: true, type: 'email' }]}>
                <Input type="email" flex defaultValue={email} onChange={(txt) => setEmail(txt)} variant="email" />
              </Form.Item>
              <Spacer />
              <Form.Item name="password" rules={[{ required: true }]}>
                <Input type={'password'} flex onChange={(txt) => setPassword(txt)} variant="password" />
              </Form.Item>
            </Box>

            {/*-----------------------------------------— //privacy and conditions checkbox -----------------------------------------— */}
            <Box id={'checkBoxItem'} mt={12}>
              <Form.Item style={{ width: '100%' }} name="terms">
                <Checkbox
                  onClick={() => setTermsCheckbox(!termsCheckbox)}
                  value={termsCheckbox}
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#A3A1AA',
                  }}
                >
                  <Box row style={{ fontSize: 14 }}>
                    {T.placeholder.iHaveReadUnderstoodAndAcceptedThe} {T.articles.the}
                    <a href="https://asters.ai/terms-of-use" target={'_blank'}>
                      <b style={{ color: AppStore.theme.o.green, marginLeft: 4 }}> {T.settings.confirmPrivacy2}</b>
                    </a>
                  </Box>
                </Checkbox>
              </Form.Item>
              <Form.Item style={{ width: '100%' }} name="privacy">
                <Checkbox
                  onClick={() => setPrivacyCheckbox(!privacyCheckbox)}
                  value={privacyCheckbox}
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#A3A1AA',
                  }}
                >
                  <Box row style={{ fontSize: 14 }}>
                    {T.placeholder.iHaveReadUnderstoodAndAcceptedThe} {T.articles.there}
                    <a href="https://asters.ai/privacy-policy" target={'_blank'}>
                      <b style={{ color: AppStore.theme.o.green, marginLeft: 4 }}> {T.logIn.privacyPolicy}</b>
                    </a>
                  </Box>
                </Checkbox>
              </Form.Item>
            </Box>
            <Spacer height="18px" />
            {!loading && (
              <Box mt={30}>
                <Button variant="primary" flex type="submit" disabled={!licenseKey}>
                  {T.labels.subscribe}
                </Button>
              </Box>
            )}
          </Box>
        </Form>
      </Box>
    )
  }

  const renderSignUpCategorySelection = () => {
    return (
      <Box flex style={{ maxWidth: 415 }}>
        <Spacer />
        <Box center>
          <img style={{ marginBottom: 20, height: 47, width: 158 }} src={asters_logo} alt="" />
        </Box>
        <Text center pr={51} pl={51} pb={18}>
          {T.logIn.welcomeYouAre[1]} <br />
          <span style={{ textAlign: 'center' }}>{T.logIn.welcomeYouAre[2]}</span>
        </Text>
        <Spacer />

        {!loading &&
          categories.map((category) => {
            return (
              <>
                <Button key={Utils.generateRandomUIDKey()} variant="neutral" flex onClick={() => onSignup(category)}>
                  {category}
                </Button>
                <Spacer height={24} />
              </>
            )
          })}
        {loading && <Lottie options={defaultOptions} height={200} width={200} />}
      </Box>
    )
  }

  const onLogin = async (fromSignUp?: boolean) => {
    if (loading) return
    try {
      setLoading(true)
      const res = await Auth.login(email, password)
      await AppStore.setToken(res.access_token)

      AppStore.loggedUser = await Auth.loggedUser()
      if (!!AppStore.loggedUser) {
        return reloadApp()
      }

      onLoginCallback(AppStore.loggedUser)

      setLoading(false)
    } catch (error) {
      setLoading(false)
      if ((error as any)?.message === 'USER_NOT_CONFIRMED') return showError(T.error.weSentAMail)

      showError(T.error.user_or_password_wrong)
    }
  }

  const renderSignUpError = () => {
    return (
      <Box flex hcenter>
        <Spacer />
        <img style={{ height: 47, width: 158 }} src={asters_logo} alt="" />
        <Spacer />
        <Card ph={20} center flex>
          <CardImage>
            <Lottie options={wrongOptions} height={90} width={90} />
          </CardImage>
          <Spacer />
          <CardText center>
            {T.logIn.error1} <br />
            {T.logIn.error2}
          </CardText>
          <Spacer />
        </Card>
        <Spacer />
        <Button
          flex
          onClick={() => {
            setSignUpStep(SIGNUPSTEPS.SIGNUP_FORM)
            setTimeout(resetState, 300)
          }}
        >
          {T.singleWord.retry}
        </Button>
      </Box>
    )
  }

  return (
    <Box flex height={750}>
      {signUpStep === SIGNUPSTEPS.SIGNUP_FORM && renderSignUpForm()}
      {signUpStep === SIGNUPSTEPS.PROFESSION_STEP && renderSignUpCategorySelection()}
      {signUpStep === SIGNUPSTEPS.LOGIN_STEP && onLogin()}
      {signUpStep === SIGNUPSTEPS.ERROR_STEP && renderSignUpError()}
    </Box>
  )
}

const CustomText = styled(Box)`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${() => AppStore.theme.o.darkGrey};
`
const Text = styled(Box)`
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  letter-spacing: 0.01em;
  color: ${() => AppStore.theme.o.black};
`
const Card = styled(Box)`
  background: ${AppStore.theme.o.background};
  border-radius: 14px;
  width: 100%;
`
const CardText = styled(Box)`
  font-weight: bold;
  font-size: 16px;
  color: ${AppStore.theme.o.black};
  text-align: center;
`
const CardImage = styled(Box)``
